"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EInventoryEvents = void 0;
var EInventoryEvents;
(function (EInventoryEvents) {
    EInventoryEvents["requests"] = "requests";
    EInventoryEvents["requestsWithLogVolume"] = "requestsWithLogVolume";
    EInventoryEvents["bidFloor"] = "bidFloor";
})(EInventoryEvents || (exports.EInventoryEvents = EInventoryEvents = {}));
